import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const TpayIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getPreRegistrationRedirectionActionImpl() {
      return () => {
        // if (this.multiOperatorInfo.multiOperatorEnabled) {
        //   this.toggleSelectOperatorModal(true);
        // } else {
        //   this.$router.push('register1');
        // }
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&msisdn=${this.$route.query.msisdn}&operator=${this.$route.query.operator}`;
      };
    },
    getIntegrationParametersCheckImpl() {
      return (to) => {
        const { status, sessionToken, cid } = to.query;
        if (status) {
          if (status === 'Error') { // wifi
            this.setCorrelationId({ value: cid || '' });
            sessionStorage.setItem('sessionToken', sessionToken);
            if (to.path === '/forgotPassword1') {
              const forgotMsisdn = sessionStorage.getItem('forgotMsisdn');
              const forgotOperator = sessionStorage.getItem('forgotOperator');
              this.storeOperator(forgotOperator);
              this.getAlternateRequestPinAction()(forgotMsisdn, forgotOperator);
            } else {
              this.toggleSelectOperatorModal(true);
            }
          }
        } else this.showPage(true);
        this.proceedToAutoLogin(to);
      };
    },

    // ----------- request/verify methods -------------------------------
    getAlternateRequestPinActionImpl() {
      return (msisdn, operator) => {
        const userMsisdn = msisdn || this.user.msisdn;
        const userOperator = operator || this.user.operator;
        const sCode = localStorage.getItem('sCode');
        const sessionToken = sessionStorage.getItem('sessionToken');
        const refCode = sessionStorage.getItem('refcode');
        this.$axios.get(`api/addContractRequest?msisdn=${userMsisdn}&lang=${this.getLocale}&referenceCode=${refCode || ''}&operator=${userOperator}&sCode=${sCode || ''}&sessionToken=${sessionToken || ''}`).then((res) => {
          const responseData = res.data.data;
          if (responseData.status === 'MSISDN_NOT_EXIST') { // success case (user not exist and about to be registered)
            const masked = responseData.msisdn;
            this.setRegistrationInfo(masked); // store masked msisdn
            sessionStorage.setItem('plain', userMsisdn);
            sessionStorage.setItem('subscriptionContractId', responseData.subscriptionContractId);
            this.toggleSelectOperatorModal(false);
            this.$router.push('/register2');
          } else if (responseData.status === 'OPERATION_SUCCESS') { // navigate away case
            const masked = responseData.msisdn;
            this.setRegistrationInfo(masked); // store masked msisdn
            this.storeOperator(userOperator);
            this.toggleSelectOperatorModal(false);
            this.$router.push('/register3');
          } else if (responseData.status === 'ALREADY_REGISTERED') {
            localStorage.setItem('sCode', '');
            this.proceedToAutoLogin({
              query: {
                user_auth_token: responseData.user_auth_token,
                username: responseData.username,
              },
            });
          } else if (responseData.status === 'ALREADY_VERIFIED') { // already sub and registered
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
          } else if (responseData.status === 'INVALID') { // invalid msisdn for operator
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
          } else if (responseData.status === 'MSISDN_BLACKLISTED') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'MSISDN_BLACKLISTED';
          } else if (responseData.status === 'DUPLICATE') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'DUPLICATE';
          } else { // error case
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
          }
        });
      };
    },
    getAlternateVerifyPinActionImpl() {
      return () => {
        const subscriptionContractId = sessionStorage.getItem('subscriptionContractId');
        const plain = sessionStorage.getItem('plain');
        this.$axios.get(`api/verifyCodeRequest?plain=${plain}&pin=${this.user.pin}&subscriptionContractId=${subscriptionContractId}&msisdn=${this.registrationInfoMsisdn}&lang=${this.getLocale}&correlationId=${this.getCorrelationId}&operator=${this.multiOperatorInfo.operatorPicked}`).then((res) => {
          if (res.data.responseEnum === 'OPERATION_SUCCESS') {
            if (res.data.data.status === 'OPERATION_SUCCESS') {
              if (res.data.data.isSub === 'true') { // hasSub
                this.$gtm.trackEvent({
                  event: 'CompleteRegistration',
                  category: 'MSISDN Registration',
                  action: 'Register 2 registration',
                  label: 'Register 2',
                });
              }
              localStorage.setItem('sCode', res.data.data.sCode);
              this.$router.push('/register3');
            } else if (res.data.data.status === 'ALREADY_REGISTERED') {
              localStorage.setItem('sCode', '');
              this.proceedToAutoLogin({
                query: {
                  user_auth_token: res.data.data.user_auth_token,
                  username: res.data.data.username,
                },
              });
            } else { // error case
              this.hasErrors = true;
              this.waitForResponse = false;
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            }
          } else { // error case
            this.hasErrors = true;
            this.waitForResponse = false;
            this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
          }
        });
      };
    },

    // ----------- reSub/unSub methods ----------------------------------
    alternateReSubActionImpl() {
      return () => {
        this.clearLoginInfo(); // logout
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&msisdn=${this.$route.query.msisdn}&operator=${this.$route.query.operator}`;
      };
    },

    // ------------- forgotPin methods --------------------------------------
    alternateForgotProcessImpl() {
      return () => {
        this.$axios.get(`api/checkSubscription?msisdn=${this.user.msisdn}&operator=${this.user.operator}`).then((response) => {
          const isReg = response.data.responseEnum === 'ALREADY_REGISTERED';
          if (isReg) this.standardForgotProcess();
          else if (response.data.responseEnum === 'MSISDN_INVALID') {
            this.message = 'visitor_forgot_password_invalid_msisdn_msg';
            this.hasErrors = true;
          } else {
            sessionStorage.setItem('forgotMsisdn', this.user.msisdn);
            sessionStorage.setItem('forgotOperator', this.user.operator);
            window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?callBack=/forgotPassword1&lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&msisdn=${this.$route.query.msisdn}&operator=${this.$route.query.operator}`;
          }
        });
      };
    },
    alternateForgotVerifyPinProcessImpl() {
      return () => {
        const hasAlt = sessionStorage.getItem('altMode') === 'true';
        if (!hasAlt) this.standardForgotVerifyPinProcess();
        else {
          const subscriptionContractId = sessionStorage.getItem('subscriptionContractId');
          const plain = sessionStorage.getItem('plain');
          this.$axios.get(`api/verifyCodeRequest?plain=${plain}&pin=${this.pin}&subscriptionContractId=${subscriptionContractId}&msisdn=${this.forgotPasswordInfo}&lang=${this.getLocale}&correlationId=${this.getCorrelationId}&operator=${this.multiOperatorInfo.operatorPicked}`).then((res) => {
            if (res.data.responseEnum === 'OPERATION_SUCCESS') {
              if (res.data.data.status === 'OPERATION_SUCCESS') {
                if (res.data.data.isSub === 'true') { // hasSub
                  this.$gtm.trackEvent({
                    event: 'CompleteRegistration',
                    category: 'MSISDN Registration',
                    action: 'Register 2 registration',
                    label: 'Register 2',
                  });
                }
                localStorage.setItem('sCode', res.data.data.sCode);
                this.setRegistrationInfo(this.forgotPasswordInfo);
                this.$router.push('/register3');
              } else if (res.data.data.status === 'ALREADY_REGISTERED') {
                localStorage.setItem('sCode', '');
                this.proceedToAutoLogin({ query: { user_auth_token: res.data.data.user_auth_token, username: res.data.data.username } });
              } else { // error case
                this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
              }
            } else { // error case
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            }
          });
        }
      };
    },
  },
};

export default TpayIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/tpayIntegration.js